import { Injectable } from '@angular/core';
import { Settings } from 'luxon';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { frontendNetworkConfig } from '../../core/network/frontend-network-config';

let currentTime = 0;
let downloadedWhen = 0;
Settings.now = () => currentTime * 1000 + (Date.now() - downloadedWhen);

@Injectable({
  providedIn: 'root',
})
export class ZalamoTimeService {
  constructor(private httpClient: HttpClient) {}

  checkTime() {
    this.httpClient
      .get(frontendNetworkConfig.timestampApi)
      .pipe(first())
      .subscribe((v) => {
        downloadedWhen = Date.now();
        currentTime = Number(v);
      });
  }
}
